import React from 'react';
import { PERIOD_LABELS } from '@/components/wyscout/MatchEvents/helpers';
import type { EventCategory, EventFiltersProps } from './types';

const categories: Array<{ value: EventCategory; label: string }> = [
  { value: 'key', label: 'Key moments' },
  { value: 'goals', label: 'Goals' },
  { value: 'shots', label: 'Shots' },
  { value: 'chances', label: 'Chances' },
  { value: 'cards', label: 'Cards' },
  { value: 'all', label: 'All events' },
];

const EventFilters: React.FC<EventFiltersProps> = ({
  category,
  team,
  period,
  availablePeriods,
  homeTeamName,
  awayTeamName,
  onCategoryChange,
  onTeamChange,
  onPeriodChange,
}) => (
  <div className="space-y-3 rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-900">
    <fieldset>
      <legend className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Event category</legend>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {categories.map(option => (
          <button
            key={option.value}
            type="button"
            aria-pressed={category === option.value}
            onClick={() => onCategoryChange(option.value)}
            className={`shrink-0 rounded-full px-3 py-1.5 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-900 ${
              category === option.value
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </fieldset>

    <div className="grid gap-3 sm:grid-cols-2">
      <label className="text-sm font-medium text-gray-700 dark:text-gray-200">
        Team
        <select
          value={team}
          onChange={event => onTeamChange(event.target.value as EventFiltersProps['team'])}
          className="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
        >
          <option value="all">Both teams</option>
          <option value="home">{homeTeamName}</option>
          <option value="away">{awayTeamName}</option>
        </select>
      </label>

      <label className="text-sm font-medium text-gray-700 dark:text-gray-200">
        Period
        <select
          value={period}
          onChange={event => onPeriodChange(event.target.value as EventFiltersProps['period'])}
          className="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
        >
          <option value="all">All periods</option>
          {availablePeriods.map(value => <option key={value} value={value}>{PERIOD_LABELS[value] || value}</option>)}
        </select>
      </label>
    </div>
  </div>
);

export default EventFilters;
